import PropTypes from 'prop-types'
import React, { useCallback, useEffect, useState } from 'react'

import Slider from '@material-ui/core/Slider'
import { makeStyles } from '@material-ui/core/styles'

const styles = (theme) => ({
  slider: {
    maxWidth: theme.spacing(96),
  },
})
const useStyles = makeStyles(styles)

export default function SeekBar(props) {
  const {
    disabled = false,
    duration,
    onPositionChange,
    onSeekingPosition,
    position = 0,
  } = props

  const [value, setValue] = useState(position)

  useEffect(() => {
    setValue(position)
  }, [position])

  const handleChange = useCallback(
    (event, sliderValue) => {
      const seekingValue = sliderValue / 100

      setValue(seekingValue)

      if (onSeekingPosition) {
        onSeekingPosition(seekingValue)
      }
    },
    [onSeekingPosition, setValue],
  )

  const handleChangeCommited = useCallback(
    (event, sliderValue) => {
      if (onPositionChange) {
        onPositionChange(sliderValue / 100)
      }
    },
    [onPositionChange],
  )

  const classes = useStyles()

  return (
    <Slider
      className={classes.slider}
      disabled={disabled || duration <= 0}
      max={duration * 100}
      onChange={handleChange}
      onChangeCommitted={handleChangeCommited}
      value={value * 100}
    />
  )
}

SeekBar.propTypes = {
  disabled: PropTypes.bool,
  duration: PropTypes.number,
  onPositionChange: PropTypes.func,
  onSeekingPosition: PropTypes.func,
  position: PropTypes.number,
}
